const router = [
  {
    path: '/consultationsv2_list',
    name: 'OverseasConsultationFormV2List',
    component: () => import('@/views/PurchaseManagement/OverseasConsultationFormV2/List.vue'),
    meta: {
      title: '海外咨询单2.0 列表'
    }
  },
  {
    path: '/push_9012',
    name: 'OverseasConsultationFormV2Push9012',
    component: () => import('@/views/PurchaseManagement/OverseasConsultationFormV2/Push.vue'),
    meta: {
      title: '海外咨询单2.0 提醒'
    }
  }
];
export default router;
